import { IcArrowDown } from '@healingpaper/cell-icons'
import { type FC, type ReactNode, type SyntheticEvent, useState } from 'react'

import { cn } from '../utils'

import FlexRow from '@/components/shared/FlexRow'

interface Props {
  title: ReactNode
  onTitleClick?: () => void
  children?: ReactNode
}

export const Collapse: FC<Props> = ({ title, onTitleClick, children }) => {
  const [open, setOpen] = useState<boolean>(false)

  const saveOpenStatus = (event: SyntheticEvent<HTMLDetailsElement>) => {
    const detailsElement = event.currentTarget as HTMLDetailsElement
    setOpen(detailsElement.open)
  }

  return (
    <details className="w-full" onToggle={saveOpenStatus}>
      <summary className="flex items-center justify-between list-none py-3">
        <FlexRow className="w-full" justify="space-between" items="center" onClick={onTitleClick}>
          <FlexRow className="flex-1">{title}</FlexRow>
          <div
            className={cn('transform transition-transform duration-200 ease-in-out', open ? 'rotate-180' : 'rotate-0')}
          >
            <IcArrowDown />
          </div>
        </FlexRow>
      </summary>

      <div className="my-4">{children}</div>
    </details>
  )
}
